import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    PagesCrawlTrigger as PagesCrawlTriggerMutation,
    PagesCrawlTriggerInput,
    PagesCrawlTriggerVariables as PagesCrawlTriggerMutationVariables,
} from 'nutshell-graphql-types';

import PAGES_CRAWL_TRIGGER from '../mutations/trigger-pages-crawl.graphql';

export const useTriggerPagesCrawl = (): {
    triggerPagesCrawl: (input: PagesCrawlTriggerInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [triggerPagesCrawl, {loading, error}] = useMutation<
        PagesCrawlTriggerMutation,
        PagesCrawlTriggerMutationVariables
    >(PAGES_CRAWL_TRIGGER);

    return {
        triggerPagesCrawl: (input: PagesCrawlTriggerInput) => {
            return triggerPagesCrawl({
                variables: {input},
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
